import React from 'react';

const PageData = React.createContext();

export default PageData;
